export default {"src":"/_next/static/media/AQN.98e07c34.svg","height":18,"width":18};